/* import __COLOCATED_TEMPLATE__ from './create-flow.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
let CreateFlow = (_class = class CreateFlow extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _defineProperty(this, "create", void 0);
    _defineProperty(this, "account", void 0);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "page", 'splash');
  }
  init(...args) {
    super.init(...args);
    set(this.automationSubaccountState, 'accountName', this.account.name);
    set(this.automationSubaccountState, 'accountId', undefined);
    if (!this.features.isEnabled('banking/access_sfs_savings')) {
      this.page = 'withholding';
    }
  }
  async continue() {
    try {
      set(this, 'isLoading', true);
      await this.create();
      set(this, 'page', 'success');
    } catch {
      set(this, 'page', 'error');
    } finally {
      set(this, 'isLoading', false);
    }
  }
  skipTarget() {
    set(this.automationSubaccountState, 'targetAmount', undefined);
    this.continue();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "continue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipTarget", [action], Object.getOwnPropertyDescriptor(_class.prototype, "skipTarget"), _class.prototype), _class);
export { CreateFlow as default };